import { Commons } from '../commons'
import Dexie from 'dexie'

class DexieDbUtils {
  constructor() {
    this.entityName = ''
    this.dbInstance = null
  }

  static getName() {
    return 'dexieDb'
  }

  async init(config) {
    const { entityName, primaryIndex = '', otherIndexes = [] } = config

    const dbInstance = new Dexie(`maketplace_merchand_${entityName}`)
    const internalConfig = buildInitiationConfig([
      { name: entityName, primaryIndex, otherIndexes },
    ])
    dbInstance.version(1).stores(internalConfig)

    this.entityName = entityName
    this.dbInstance = dbInstance
    return { success: true, database: this }
  }

  async deleteAll() {
    await this.dbInstance[this.entityName].clear()
  }

  async deleteOne(id) {
    await this.dbInstance[this.entityName].delete(id)
  }

  async findOne(id) {
    const data = await this.dbInstance[this.entityName].get(id)
    return data
  }

  async getAll(orderKey, orderDesc, offset, limit) {
    let query = this.dbInstance[this.entityName]
    if (orderKey) query = query.orderBy(orderKey)
    if (orderKey && orderDesc) query = query.reverse()
    if (offset) query = query.offset(offset)
    if (limit) query = query.limit(limit)

    const data = await query.toArray()
    return data
  }

  async find(filterCriteria, orderKey, orderDesc, offset, limit) {
    if (Commons.isEmpty(filterCriteria)) {
      return this.getAll(orderKey, orderDesc, offset, limit)
    }

    const filters = getFilterFunctions(filterCriteria)

    let query = this.dbInstance[this.entityName]
    if (orderKey) query = query.orderBy(orderKey)
    if (orderKey && orderDesc) query = query.reverse()

    query = query.filter(element => {
      let allFiltersMatch = true
      filters.forEach(filter => {
        const success = filter(element)
        if (!success) allFiltersMatch = false
      })
      return allFiltersMatch
    })

    if (offset) query = query.offset(offset)
    if (limit) query = query.limit(limit)

    const data = await query.toArray()
    return data
  }

  async count() {
    let query = this.dbInstance[this.entityName]
    const count = await query.count()
    return count
  }

  async save(data) {
    if (!data) {
      console.error('data has no content', data)
      return
    }
    if (Array.isArray(data)) {
      await this.dbInstance[this.entityName].bulkPut(data)
      return
    }
    await this.dbInstance[this.entityName].put(data)
  }
}

function buildInitiationConfig(entities) {
  if (Commons.isEmpty(entities)) return
  const configs = {}
  entities.forEach(entity => {
    if (!entity.name) return
    let storeConfig = ''
    if (entity.primaryIndex) storeConfig += `&${entity.primaryIndex}`
    else storeConfig += '++'
    if (!Commons.isEmpty(entity.otherIndexes)) {
      entity.otherIndexes.forEach(key => {
        if (storeConfig) storeConfig += ', '
        storeConfig += key
      })
    }
    configs[entity.name] = storeConfig
  })
  return configs
}

function getFilterFunctions(filterCriteria) {
  const filterRest = JSON.parse(JSON.stringify(filterCriteria))
  const filterFunctions = []
  Object.keys(filterRest).forEach(key => {
    let filterAdded = false
    if (typeof filterRest[key]?.gte == 'number') {
      filterFunctions.push(function (element) {
        return element[key] >= filterCriteria[key].gte
      })
      filterAdded = true
    }
    if (typeof filterRest[key]?.gt == 'number') {
      filterFunctions.push(function (element) {
        return element[key] > filterCriteria[key].gt
      })
      filterAdded = true
    }
    if (typeof filterRest[key]?.lte == 'number') {
      filterFunctions.push(function (element) {
        return element[key] <= filterCriteria[key].lte
      })
      filterAdded = true
    }
    if (typeof filterRest[key]?.lt == 'number') {
      filterFunctions.push(function (element) {
        return element[key] < filterCriteria[key].lt
      })
      filterAdded = true
    }
    if (filterAdded) delete filterRest[key]
  })
  if (Object.keys(filterRest).length > 0) {
    filterFunctions.push(function (element) {
      const keys = Object.keys(filterRest)
      let allKeysMatch = true
      keys.forEach(key => {
        if (element[key] != filterCriteria[key]) allKeysMatch = false
      })
      return allKeysMatch
    })
  }
  return filterFunctions
}

export { DexieDbUtils }
